<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100]">
  <div class="rounded-lg shadow-xl w-full max-w-md p-4 overflow-hidden bg-white z-1050">
    <!-- Header -->
    <div class="flex justify-between items-start">
      <h3 class=" text-metro-blue-secondary">{{localizedTitle}}</h3>
    </div>

    <!-- Body -->
    <div>
      <p class="text-metro-blue" [innerHTML]="localizedMsg"></p>
    </div>

    <!-- Footer -->
    <div class=" flex justify-end gap-3">
      @if (cancelText) {
      <app-metro-button [text]="cancelText" variant="secondary" [fullWidth]="false"
        (clicked)="confirmed.emit(false)"></app-metro-button>
      }

      <app-metro-button [text]="confirmText" [fullWidth]="false" (clicked)="confirmed.emit(true)"></app-metro-button>
    </div>

  </div>
</div>
